import React from 'react'

type Props = {
  remoteVideoRef: React.RefObject<HTMLVideoElement>
}

const ParticipantCamera = (props: Props) => {
  const { remoteVideoRef } = props
  return (
    <div className="flex-1 w-full">
      <video
        ref={remoteVideoRef}
        autoPlay
        playsInline
        style={{
          aspectRatio: '16/12',
          backgroundColor: 'black'
        }}
        className="min-w-[18rem] z-50 overflow-hidden w-full rounded-md border border-black"></video>
    </div>
  )
}

export default ParticipantCamera
